// extracted by mini-css-extract-plugin
export default {"app":"App_app__m5U+3","cta-button":"App_cta-button__jIB9O"};